import {Component} from 'react';
import h from 'react-hyperscript';
import {p, eyebrow} from 'Components/Typography/Typography';
import Button from 'Components/Buttons/Buttons';
import {RESOURCE} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';

class ClassromDisabled extends Component {
  render() {
    return (
      h('div', null, [
        h('div', {
          id: 'classroom-disabled__container',
          className: 'flex--wrap-all flex--center',
        }, [
          h(p, {
            className: 'text--center text--grey',
          }, this.props.content.title),
          h(Button, {
            key: 'classroom-disabled__button',
            id: 'classroom-disabled__button',
            to: this.props.content.cta.href,
            external: true,
            className: 'button--centered button--long margin-top--md',
            type: 'basic',
          },
          this.props.content.cta.text
          ),
        ]),
        h('div', {className: 'classroom__resources'}, [
          h(eyebrow, {
            key: `disabled-eyebrow`,
            className: 'padding-bottom--sm padding-top--lg',
          }, this.props.content.resources.title),
          h('ul', {
            key: `disabled-resources`,
            className: 'list--blank',
          }, this.props.content.resources.items.map((item, i) => {
            const href = item.href;
            return (
              h('li', {
                key: `tab-resources-list-item${i}`,
              }, h('a', {
                href,
                target: '_blank',
                className: 'text--blue',
                onClick: () => {
                  pushGTMEvent(RESOURCE.TAG, {
                    event: RESOURCE.EVENT,
                    action: {resource_action: RESOURCE.ACTION.RESOURCE_CLICK},
                    variables: {
                      resource_category: 'Classroom Activity',
                      resource_url: href,
                    },
                  });
                },
              }, item.title))
            );
          })),
        ]),
      ])
    );
  }
}

export default ClassromDisabled;
